import { useMutation } from '@tanstack/react-query';
import { clsx } from 'clsx';
import { billingApi } from '~/lib/api';

/**
 * Shared upgrade CTA used on premium-gated surfaces (play detail context,
 * traders alerts, plays history preview, etc.). Kicks off a Stripe checkout
 * session on click and redirects the browser to it.
 */
export function UpgradePrompt({
  headline,
  subline,
  buttonLabel = 'Upgrade',
  className,
}: {
  headline: string;
  subline?: string;
  buttonLabel?: string;
  className?: string;
}) {
  const checkoutMutation = useMutation({
    mutationFn: billingApi.createCheckout,
    onSuccess: (data) => {
      window.location.href = data.url;
    },
  });

  return (
    <div className={clsx('text-center space-y-3', className)}>
      <p className="text-sm text-text-secondary">
        <span className="text-warning font-semibold">{headline}</span>
        {subline && <span className="text-text-muted"> — {subline}</span>}
      </p>
      <button
        type="button"
        onClick={() => checkoutMutation.mutate()}
        disabled={checkoutMutation.isPending}
        className="px-6 py-3 bg-gradient-to-r from-yellow-400 to-yellow-500 hover:from-yellow-300 hover:to-yellow-400 text-gray-900 font-bold rounded-lg transition-all shadow-lg shadow-yellow-500/25 hover:shadow-yellow-500/40 hover:scale-105 text-sm sm:text-base"
      >
        {checkoutMutation.isPending ? 'Loading…' : buttonLabel}
      </button>
      {checkoutMutation.isError && (
        <p className="text-loss text-xs">
          Couldn't start checkout. {(checkoutMutation.error as Error).message}
        </p>
      )}
    </div>
  );
}
